import base from './base'
import { getDeviceType } from './http'
const baseURL = process.env.VUE_APP_API_BASE_URL || '/api'

export default {
  getModuleDetail(params) {
    return base.get('/ai/doctor/detail', params)
  },

  // 获取话题列表
  getTopicList(params) {
    return base.get('/ai/doctor/topicList', params)
  },

  // 获取话题详情
  getTopicDetail(params) {
    return base.get('/ai/doctor/topicDetail', params)
  },

  // 删除话题
  deleteTopic(params) {
    return base.post('/ai/doctor/deleteTopic', params)
  },

  async streamChat(params) {
    const response = await fetch(`${baseURL}/ai/Doctor/chat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/event-stream',
        'XX-Api-Version': '1.0',
        'Accept-Language': 'zh-cn',
        'XX-Device-Type': getDeviceType(),
        'XX-Token': localStorage.getItem('authToken') || ''
      },
      body: JSON.stringify(params)
    })

    return response
  }
}
